import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, TextField, Typography } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';

import { Context } from '../context/DataContext';
import PasswordField from '../components/form/PasswordField';

const LoginPage = () => {
  const navigate = useNavigate();
  const [values, setValues] = React.useState({ account: '', password: '' });
  const [errorMsg, setErrorMsg] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const { account, password } = values;
  const { login } = React.useContext(Context);

  const handleChange = (prop) => (e) =>
    setValues({
      ...values,
      [prop]: e.target.value,
    });

  const handleSubmit = () => {
    if (errorMsg) setErrorMsg('');

    if (account && password) {
      setLoading(true);
      login({ userId: account, userPw: password }, (data) => {
        const {
          rtnObj: { ResponseCode, ResponseMSG, Attribute4 },
        } = data;

        setLoading(false);
        if (ResponseCode !== '1') {
          setErrorMsg(ResponseMSG);
        } else {
          if (Attribute4) {
            navigate('/dashboard');
          } else {
            setErrorMsg('登入失敗');
          }
        }
      });
    } else {
      setErrorMsg('請輸入帳號密碼');
    }
  };

  return (
    <Box
      sx={(theme) => ({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: `calc(80vh - ${theme.mixins.toolbar.minHeight}px)`,
      })}
    >
      <Typography variant='h4' sx={{ my: 2 }}>
        銷售登入
      </Typography>
      <Box
        component='form'
        sx={{ px: 3, '& > :not(style)': { my: 1 } }}
        noValidate
        autoComplete='off'
      >
        <TextField
          fullWidth
          id='user-account'
          label='帳號'
          variant='outlined'
          value={account}
          onChange={handleChange('account')}
        />
        <PasswordField
          fullWidth
          id='user-password'
          label='密碼'
          variant='outlined'
          value={password}
          onChange={handleChange('password')}
          onEnter={handleSubmit}
        />
        {errorMsg ? (
          <Typography variant='h6' sx={{ my: 2, color: 'red' }}>
            {errorMsg}
          </Typography>
        ) : null}
        <LoadingButton
          variant='contained'
          sx={{ width: 168 }}
          loading={loading}
          onClick={handleSubmit}
        >
          登入
        </LoadingButton>
      </Box>
    </Box>
  );
};

export default LoginPage;
